import React, { useRef, useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';
import axios from 'axios';

function Contact() {
  const formRef = useRef();
  const [notification, setNotification] = useState({ visible: false, message: '' });
  const [contactData, setContactData] = useState(null);

  // Fetch contact data
  useEffect(() => {
    axios.get('/data/data.json')
      .then((response) => {
        setContactData(response.data.contacts);
      })
      .catch((error) => {
        console.error('Error fetching contact data:', error);
      });
  }, []);

  // Handle form submission
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_eb4oj81', 'template_0c2hl09', formRef.current, 'WSx81a6mkPJ_G0Heb')
      .then((result) => {
        console.log(result.text);
        setNotification({ visible: true, message: 'Message sent successfully!' });
        formRef.current.reset(); // Clear form fields after submission
        setTimeout(() => setNotification({ visible: false, message: '' }), 5000); // Hide notification after 5 seconds
      }, (error) => {
        console.log(error.text);
        setNotification({ visible: true, message: 'Failed to send message. Please try again.' });
        setTimeout(() => setNotification({ visible: false, message: '' }), 5000); // Hide notification after 5 seconds
      });
  };

  // Helper function to handle focus and blur
  const handleFocus = (e) => {
    const parent = e.target.parentNode;
    parent.classList.add('focus');
  };

  const handleBlur = (e) => {
    const parent = e.target.parentNode;
    if (e.target.value === "") {
      parent.classList.remove('focus');
    }
  };

  if (!contactData) {
    return <div style={{ textAlign: 'center' }}>Loading Contact Screen...</div>; // Loading state until the data is fetched
  }

  return (
    <section className="contact section" id="contact">
      <h2 data-heading="Get in touch" className="section__title">Contact Me</h2>

      <div className="contact__container container grid">
        <div className="contact__content">
          <div className="contact__info">
            <div className="contact__card">
              <i className="uil uil-envelope-edit contact__card-icon"></i>
              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">{contactData.email.address}</span>
              <span className="contact__button">
                <a href={contactData.email.url}>Write Me <i className="uil uil-arrow-right contact__button-icon"></i></a>
              </span>
            </div>

            <div className="contact__card">
              <i className="uil uil-whatsapp contact__card-icon"></i>
              <h3 className="contact__card-title">Whatsapp</h3>
              <span className="contact__card-data">{contactData.whatsapp.phone}</span>
              <span className="contact__button">
                <a href={contactData.whatsapp.url}>Write Me <i className="uil uil-arrow-right contact__button-icon"></i></a>
              </span>
            </div>

            <div className="contact__card">
              <i className="uil uil-linkedin contact__card-icon"></i>
              <h3 className="contact__card-title">Linkedin</h3>
              <span className="contact__card-data">Pratyush Kumar</span>
              <span className="contact__button">
                <a href={contactData.linkedin.url}>Write Me <i className="uil uil-arrow-right contact__button-icon"></i></a>
              </span>
            </div>
          </div>
        </div>

        <div className="contact__content">
          <form ref={formRef} onSubmit={sendEmail} className="contact__form">
            <div className="input__container">
              <input
                type="text"
                name="username"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              />
              <label>Username</label>
              <span>Username</span>
            </div>

            <div className="input__container mail">
              <input
                type="email"
                name="email"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              />
              <label>Email</label>
              <span>Email</span>
            </div>

            <div className="input__container mail">
              <input
                type="tel"
                name="phone"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              />
              <label>Phone</label>
              <span>Phone</span>
            </div>

            <div className="input__container textarea">
              <textarea
                name="message"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              ></textarea>
              <label>Message</label>
              <span>Message</span>
            </div>

            <button type="submit" className="button">
              <i className="uil uil-navigator button__icon"></i> Send Message
            </button>
          </form>
        </div>
      </div>

      {/* Notification Box */}
      {notification.visible && (
        <div className={`contact-notification-box show`}>
          {notification.message}
        </div>
      )}
    </section>
  );
}

export default Contact;
